/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Shared react-select style factories for ViewAppointments filters.
 * @module pages/viewAppointments/viewAppointmentsSelectStyles
 */

import { hideSelectIndicatorSeparator } from "../../utils/reactSelectFieldUtils.jsx";
import {
  FILTER_SELECT_CONTROL_HEIGHT,
  FILTER_SELECT_MENU_Z_INDEX,
  FILTER_SELECT_VALUE_PADDING,
  SELECT_CONTROL_HEIGHT,
  SELECT_CONTROL_WIDTH,
  SELECT_MENU_Z_INDEX,
  SELECT_VALUE_PADDING,
} from "./viewAppointmentsConstants.js";

/**
 * Primary select styles for buyer, executive, and requirement pickers.
 * @param {Object} [options]
 * @param {boolean} [options.disabled=false]
 * @returns {Object}
 */
export const buildPrimarySelectStyles = ({ disabled = false } = {}) => ({
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    width: SELECT_CONTROL_WIDTH,
    height: SELECT_CONTROL_HEIGHT,
    fontSize: "14px",
    cursor: disabled ? "not-allowed" : "pointer",
    textAlign: "left",
    borderColor: "#909092",
    backgroundColor: "#FCFCFC",
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    width: SELECT_CONTROL_WIDTH,
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: SELECT_VALUE_PADDING,
  }),
  input: (baseStyles) => ({ ...baseStyles }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: SELECT_MENU_Z_INDEX,
  }),
  menuPortal: (baseStyles) => ({
    ...baseStyles,
    zIndex: SELECT_MENU_Z_INDEX,
  }),
  indicatorSeparator: hideSelectIndicatorSeparator,
});

/** Compact select styles used inside the filters dropdown portal. */
export const filterDropdownSelectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    width: "100%",
    height: FILTER_SELECT_CONTROL_HEIGHT,
    fontSize: "14px",
    cursor: "pointer",
    borderColor: "#909092",
    backgroundColor: "#FCFCFC",
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    width: "100%",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: FILTER_SELECT_VALUE_PADDING,
  }),
  input: (baseStyles) => ({ ...baseStyles }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: FILTER_SELECT_MENU_Z_INDEX,
  }),
  menuPortal: (baseStyles) => ({
    ...baseStyles,
    zIndex: FILTER_SELECT_MENU_Z_INDEX,
  }),
  indicatorSeparator: hideSelectIndicatorSeparator,
};
